import React, { useEffect, useState } from 'react';
import {
    Panel,
    IPanelStyles,
    PanelType,
} from '@fluentui/react';
import LoaderComponent from '../loader/loader.component';
import ErrorMessageComponent from '../error-message/error-message.component';

import useAuthStatus from '../../hooks/auth/AuthHook';
import ApiService from '../../services/api/api.service';

import ItemTarea from '../../models/ItemTarea';

const panelStyles : IPanelStyles = {
    root: {},
    overlay: {},
    hiddenPanel: {},
    main: {},
    commands: {
        marginTop: 0,
    },
    contentInner: {},
    scrollableContent: {},
    navigation: {
        backgroundColor: 'var(--color-primario)',
        padding: 10,
        alignItems: 'center',
    },
    header: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5,
    },
    headerText: {
        color: '#ffffff',
    },
    content: {
        padding: 0,
    },
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: '#ffffff',
                backgroundColor: 'transparent',
                padding: 0,
            },
            rootHovered: {
                backgroundColor: '#000000',
                color: '#ffffff',
                borderColor: '#000000',
            },
        },
    },
};

interface IWorkPartFinishInfoComponentProps {
    work: ItemTarea;
    onClose: () => void;
};

const WorkPartFinishInfoComponent = (props: IWorkPartFinishInfoComponentProps) => {
    const auth = useAuthStatus();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [informeActuacion, setInformeActuacion] = useState<string>('');

    useEffect(() => {
        if (auth.user) {
            setLoading(true);
            ApiService.Post<string>(`OrdenesTrabajo`, `GetInformeActuacion`, auth.user, {
                IdTarea: props.work.Id,
            }).then((response: string) => {
                setInformeActuacion(response);
                setLoading(false);
            }, (error: string) => {
                setError(error);
                setLoading(false);
            });
        }
    }, [auth.user, props.work.Id]);

    return (
        <Panel
            isOpen={true}
            headerText="Informe de actuación"
            onDismiss={props.onClose}
            styles={panelStyles}
            type={PanelType.medium}>
            <div className="container-fluid p-0">
                <div className='row m-0'>
                    <div className='col-12 p-0'>
                        <div
                            className='w-100'
                            dangerouslySetInnerHTML={{ __html: informeActuacion }}></div>
                    </div>
                </div>
                <div className='row m-0'>
                    <div className='col-12'>
                        <ErrorMessageComponent message={error} />
                    </div>
                </div>
            </div>
            <LoaderComponent loading={loading} />
        </Panel>
    );
};

export default WorkPartFinishInfoComponent;
